export const ExternalNavigate = ({to}: {to: string}) => {
    window.location.href = to;
    return null;
}
